import Vue from 'vue'

let apiGet = Vue.axios.create({
  method: 'GET',
  baseURL: '/'
})
export default {
  getProvince: (opt, baseUrl) => {
    return apiGet({url: baseUrl + 'service/rest/tk.Zone/' + opt + '/childNodes'})
  },
  sendImage: (code, opt, baseUrl) => {
    let apiPostToken;
    if (code && code.length >= 1) {
      apiPostToken = Vue.axios.create({
        baseURL: baseUrl,
        headers: {
          'X-CSRF-TOKEN': code
        }
      })
    } else {
      apiPostToken =  Vue.axios.create({
        baseURL: baseUrl
      })
    }
    return apiPostToken.post('service/rest/tk.File/collection/upload', opt)
  },
  getCsrf: (baseUrl) => {
    return apiGet({url: baseUrl + 'service/rest/fw.System/collection/csrf'})
  },
  getColle: (baseUrl) => {
    return apiGet({url: baseUrl + 'service/rest/fw.System/collection/key'})
  },
  sendVideo: (code, opt, baseUrl, url) => {
    let apiPostToken;
    if (code && code.length >= 1) {
      apiPostToken = Vue.axios.create({
        baseURL: baseUrl,
        headers: {
          'X-CSRF-TOKEN': code
        }
      })
    } else {
      apiPostToken =  Vue.axios.create({
        baseURL: baseUrl
      })
    }
    return apiPostToken.post(url, opt)
  }
}
